import normalizePathname from '@/lib/routes/normalizePathname.js';

const readCurrentPieveRoutePathname = () => {
  if (typeof window === 'undefined' || !window.location) {
    return '/';
  }

  const protocol = String(window.location.protocol || '')
    .trim()
    .toLowerCase();

  if (protocol === 'file:') {
    const normalizedHash = String(window.location.hash || '')
      .trim()
      .replace(/^#/, '');
    const hashPath = normalizedHash.split('?')[0] || '/';

    return normalizePathname(hashPath);
  }

  return normalizePathname(window.location.pathname || '/');
};

export default readCurrentPieveRoutePathname;
